module.exports = __webpack_public_path__ + "static/media/undraw_performance_overview_p9bm.931e8433.svg";